var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ad-page',{attrs:{"title":"广告收益"}},_vm._l((20),function(item,index){return _c('v-item',{key:index,staticClass:"profit-item"})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }